import React from 'react';
import CompanyList from '../components/CompanyList';

const Companies: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <CompanyList />
    </div>
  );
};

export default Companies;
